import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EEstimateSource;
(function (EEstimateSource) {
  EEstimateSource["ChangeHealthcare"] = "change-healthcare";
})(EEstimateSource || (EEstimateSource = {}));
export const fieldsEstimate = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  date: {
    type: 'Date'
  },
  fileUpload: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  message: {
    type: 'ID',
    ref: EModel.Message
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  payCode: {
    type: 'Object'
  },
  readAt: {
    type: 'Date'
  },
  searchIds: {
    type: 'Text',
    array: true
  },
  source: {
    type: 'Option',
    values: EEstimateSource
  },
  totalPatientAmountInCents: {
    type: 'Number'
  },
  visible: {
    type: 'Boolean'
  }
});